var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "main container" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "col-md-12 text-center" }, [
      _c("h4", { staticClass: "highlight-color" }, [
        _vm._v(_vm._s(_vm.$t("message.title_createstore")))
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "col-md-6 form" }, [
      _c("div", { staticClass: "form-group" }, [
        _c("label", [_vm._v(_vm._s(_vm.$t("placeholder.shopname")))]),
        _vm._v(" "),
        _c("input", { staticClass: "form-control", attrs: { type: "email" } })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group" }, [
        _c("label", [_vm._v(_vm._s(_vm.$t("placeholder.businesstype")))]),
        _vm._v(" "),
        _c("input", { staticClass: "form-control", attrs: { type: "text" } })
      ]),
      _vm._v(" "),
      _c(
        "button",
        { staticClass: "btn btn-web btn-block", attrs: { type: "submit" } },
        [_vm._v(_vm._s(_vm.$t("message.create")))]
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "col-md-12 text-center" },
      [
        _c(
          "router-link",
          { staticClass: "txt-white", attrs: { to: { name: "ChooseShop" } } },
          [
            _vm._v(
              "\n      " +
                _vm._s(_vm.$t("message.title_choosestore")) +
                "\n    "
            )
          ]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "logo col-md-12 text-center" }, [
      _c("img", { attrs: { src: require("./../../assets/logo-10.png") } })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-619ed938", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-619ed938","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/account/CreateShop.vue
// module id = null
// module chunks = 